import React, { useEffect, useMemo, useState } from "react";
import Header, { QDMonogram } from "../components/Header";
import SideMenu from "../components/SideMenu";
import Deck from "../components/Deck";
import api from "../lib/api";

export default function Home() {
  const [articles, setArticles] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const [category, setCategory] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [news, set] = await Promise.all([
          api.get("/news"),
          api.get("/settings"),
        ]);
        setArticles(news.data);
        setSettings(set.data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const filtered = useMemo(
    () => (category ? articles.filter((a) => a.category === category) : articles),
    [articles, category]
  );

  return (
    <div className="App relative">
      <Header onMenuClick={() => setMenuOpen(true)} menuOpen={menuOpen} />
      <SideMenu
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        onSelectCategory={setCategory}
        activeCategory={category}
      />

      {loading ? (
        <div className="w-full h-full flex flex-col items-center justify-center bg-[#FDFBF7] gap-5">
          <QDMonogram size={72} />
          <div data-testid="loading" className="font-serif-display text-2xl text-[#1A1A1A] tracking-[0.2em] uppercase">
            Queens <span className="italic font-light">Daily</span>
            <span className="inline-block ml-2 w-1.5 h-1.5 rounded-full bg-[#D4A373] animate-pulse" />
          </div>
        </div>
      ) : filtered.length === 0 ? (
        <EmptyState onClearCategory={() => setCategory(null)} />
      ) : (
        <Deck articles={filtered} settings={settings} />
      )}
    </div>
  );
}

function EmptyState({ onClearCategory }) {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center bg-[#FDFBF7] px-6 text-center">
      <p className="overline text-[#76746F] mb-4">Nothing here yet</p>
      <h2 className="font-serif-display text-4xl sm:text-5xl mb-6">
        No stories in this section.
      </h2>
      <button
        data-testid="clear-filter"
        onClick={onClearCategory}
        className="px-6 py-3 rounded-full border border-black/20 hover:bg-black hover:text-white hover:border-black transition-colors text-sm"
      >
        See all stories
      </button>
    </div>
  );
}
